// extracted by mini-css-extract-plugin
export default {"plansSection":"PricingPlans_plansSection__nPooX","On":"PricingPlans_On__U8kTD","plansCon":"PricingPlans_plansCon__GGO18"};